import React from 'react';

const Logo = ({ size = "text-xl", className = "" }) => {
  return (
    <div className={`select-none ${className}`}>
      <span className={`font-['Poppins'] font-bold tracking-tight ${size}`}>
        <span className="text-blue-500">myAnime</span>
        <span className="text-white">Tracker</span>
      </span>
    </div>
  );
};

export default Logo;